<template>
    <div class="container mt-2 pt-5">
        <h1 class="mb-4">{{ t('Privacy policy') }}</h1>

        <p class="text-muted">
            {{ t('Privacy policy placeholder', 'This privacy policy describes how Cleanfix Connect collects, uses and protects your personal data.') }}
        </p>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>

</style>
